import { render, staticRenderFns } from "./DomesticPoolsForm.vue?vue&type=template&id=3b6dd7a2&scoped=true&"
import script from "./DomesticPoolsForm.vue?vue&type=script&lang=js&"
export * from "./DomesticPoolsForm.vue?vue&type=script&lang=js&"
import style0 from "./DomesticPoolsForm.vue?vue&type=style&index=0&id=3b6dd7a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6dd7a2",
  null
  
)

export default component.exports